type DateFormatPreset =
  | 'withSeconds'
  | 'long'
  | 'longWithTimeZone'
  | 'short'
  | 'iso'
  | 'timeOnly'
  | 'withoutSeconds'
  | 'dateShortAndTimeWithoutSec'

const formatPresets: Record<DateFormatPreset, Intl.DateTimeFormatOptions> = {
  withSeconds: {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  },
  long: {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  },
  longWithTimeZone: {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short',
  },
  short: {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  },
  iso: {}, // Вернёт просто toLocaleString как есть
  timeOnly: {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  },
  withoutSeconds: {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  },
  dateShortAndTimeWithoutSec: {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  },
}

export function formatDate(
  dateString: string,
  preset: DateFormatPreset = 'long',
  optionsOverride: Intl.DateTimeFormatOptions = {},
  replaceComma = false
): string {
  const date = new Date(dateString)

  // Объединяем пресет и возможные override опции
  const options = { ...formatPresets[preset], ...optionsOverride }

  let formatted = date.toLocaleString('ru-RU', options)

  if (replaceComma) {
    formatted = formatted.replace(',', '')
  }
  return formatted
}

export function formatTimeFromSeconds(seconds: number): string {
  const days = Math.floor(seconds / 86400)
  const hours = Math.floor((seconds % 86400) / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)

  const parts = []
  if (days) parts.push(`${days} д`)
  if (hours || days) parts.push(`${hours} ч`)
  parts.push(`${minutes} мин`)

  return parts.join(' ')
}
